import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RoutesStatesNamesEnum } from '@uigy/shared/enums/routesStatesNames.enum';
import { PcapPlayerComponent } from '@uigy/modules/settings/modules/pcap-player/components/pcap-player/pcap-player.component';
import { CanDeactivateGuard } from '@uigy/core/guards/can-deactivate.guard';
import { setCapabilitiesRouteData } from '@uigy/shared/capabilities/capabilities-route-data';
import { Capability } from '@uigy/generated/graphql';
import { IcpGuard } from '@uigy/core/guards/icp.guard';
import { CapabilityGuardCanActivate } from '@uigy/core/guards/capability.guard';

@NgModule({
  imports: [RouterModule.forChild([{
      path: RoutesStatesNamesEnum.settingsPcapPlayer,
      component: PcapPlayerComponent,
      canDeactivate: [CanDeactivateGuard],
    canActivate: [CapabilityGuardCanActivate, IcpGuard],
      data: setCapabilitiesRouteData(Capability.PcapPlayer),
    }]
  )],
  exports: [RouterModule]
})
export class PcapPlayerRoutingModule {
}
